import { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import OrangeChevronImage from "../../assets/images/background/OrangeChevron_Centred_3127x2067.png";
import Deltorian from "../../assets/images/deltorian/Deltorian.svg";
import { Button, Grid, Stack, useMediaQuery, useTheme } from "@mui/material";
import RecentQuotes from "../RecentQuotesTable";
import { MixpanelWrapper } from "../MixPanelWrapper";
import { colours } from "../../shared/colors";
import { useDispatch } from "react-redux";
import { clearQuoteId, resetStage, setQuoteId } from "../../services/features/quoteSlice/quoteSlice";

/**
 * Component for the home page.
 *
 * This component displays the home page user interface, including options to start a new quote,
 * contact information, and a list of recent quotes. It also tracks user interactions with Mixpanel.
 *
 * @returns {JSX.Element} The rendered home page UI.
 */
const HomePage = () => {
	const theme = useTheme();
	const isGreaterThanSmallScreen = useMediaQuery(theme.breakpoints.up("sm"));

    const dispatch = useDispatch();

	let navigate = useNavigate();

	const goToCreateQuote = () => {
		// let path = `newPath`;
        dispatch(clearQuoteId());
        dispatch(resetStage());
		MixpanelWrapper.track("Home Page - Create Quote Button");
		navigate("/create-quote", { state: { createQuote: true } });
	};

	useEffect(() => {
		dispatch(clearQuoteId());
        dispatch(resetStage());
		MixpanelWrapper.track("Home Page");
	}, []);

	return (
		<Stack>
			<Box
				width="100%"
				height="25vh"
				sx={{
					position: "relative",
					backgroundColor: colours.primaryDark.main,
					borderRadius: "10px",
					overflow: "hidden",
				}}
			>
				<Box
					sx={{
						position: "absolute",
						top: 0,
						left: 0,
						height: "100%",
						width: isGreaterThanSmallScreen ? "40%" : "100%",
						backgroundImage: `url(${OrangeChevronImage})`,
						backgroundPosition: "left",
						backgroundSize: "cover",
						backgroundRepeat: "no-repeat",
						borderTopLeftRadius: "10px",
						borderBottomRightRadius: "10px",
					}}
				/>
				<Box
					sx={{
						position: "relative",
						zIndex: 1,
						height: "100%",
						width: "100%",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						color: "#ffffff",
					}}
				>
					<Grid container p={2} px={3} justifyContent="center" alignItems="center">
						<Grid
							item
							xs={4}
							display="flex"
							justifyContent="flex-end"
							p={isGreaterThanSmallScreen ? 3 : 0}
						>
							<Box width={isGreaterThanSmallScreen ? "15vh" : "100%"} pl="2em">
								<img src={Deltorian} alt="Deltorian" />
							</Box>
						</Grid>
						<Grid item xs={true}>
							<Typography
                                variant="h3"
								color="inherit"
								fontWeight={800}
                                mb={"0.25em"}
							>
								Start a new quote
							</Typography>
							<Button variant="contained" sx={{ mt: 2 }} onClick={goToCreateQuote}>
								Create Quote
							</Button>
						</Grid>
					</Grid>
				</Box>
			</Box>
			<RecentQuotes />
		</Stack>
	);
};

export default HomePage;
